import { ValidationProvider, ValidationObserver } from "vee-validate/dist/vee-validate.full.esm";
import Autenticado from "@/views/Templates/Autenticado/Autenticado.vue";
import DgoContainer from "@/components/DGOContainer/DGOContainer.vue";
import DgoRow from "@/components/DGORow/DGORow.vue";
import DgoCol from "@/components/DGOCol/DGOCol.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import { arrHasAnyEqualVal } from "@/helpers/helpers";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        DgoContainer,
        DgoRow,
        DgoCol,
        Autenticado,
    },
    data() {
        return {
            form: {
                first_name: '',
                last_name: '',
                email: '',
                email_subscription: false,
            }
        };
    },
    computed: {
        ...mapState('user', {
            user: 'data',
            successUser: 'success',
            errorUser: 'error',
            loadingUser: 'loading',
        }),
    },
    watch: {
        user() { this.setFields(); }
    },
    methods: {
        ...mapMutations('user', ['setNewUserData']),
        ...mapActions('user', ['updateUser']),
        setFields() {
            for (let field in this.form) {
                this.form[field] = this.user[field];
            }
        },
        async onSubmit() {
            this.setNewUserData(this.form);
            const user = await this.updateUser();

            if (user) {
                this.$router.push('/arquivos');
            } else {
                const hasFieldsError = arrHasAnyEqualVal(this.form, this.errorResetPass);
                if (hasFieldsError) { this.$refs.form.setErrors(this.errorResetPass); }
            }
        }
    },
    created() {
        this.setFields();
    }
}
